import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { selectorLanguage } from '@app/core/nav/lang-switcher/lang.reducer';

@Component({
  selector: 'cloud-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.scss']
})
export class LangSwitcherComponent implements OnInit {

  constructor(
    private translateService: TranslateService,
    private store: Store<any>,
  ) {
    this.translateService = translateService;
    this.translateService.setDefaultLang('bg');
  }

  ngOnInit() {
    this.store
      .select(selectorLanguage)
      .subscribe(lang => { this.set(lang); });
  }

  changeLanguage(language: string): void {
    this.set(language === 'bg' ? 'en' : 'bg');
  }

  set(language: string) {
    this.store.dispatch({ type: language });
    this.translateService.use(language);
  }

  get currentLang() {
    return this.translateService.currentLang;
  }
  get otherLang() {
    return (this.currentLang === 'bg') ? 'en' : 'bg';
  }

}
